<template>
    <BaseSection width="page-narrow" class="section--accordion">
        <template v-if="header" v-slot:title>{{ header }}</template>
        <TheAccordion
            :items="accordion"
            class="accordion"
        >
            <template #title="{ item }">
                {{ item.label }}
            </template>
            <template #default="{ item }">
                <div v-html="item.richText" /> <!-- eslint-disable-line vue/no-v-html -->
            </template>
            <template #icon>
                <BaseIcon icon="plus-circle" />
            </template>
        </TheAccordion>
    </BaseSection>
</template>

<script setup>
defineProps({
    accordion: {
        type: Array,
        default: null
    },
    header: {
        type: String,
        default: ''
    },
    background: {
        type: String,
        default: 'default'
    }
});
</script>

<style lang="less" scoped>
.section--accordion {
    .section__body {
        margin-top: 1.5rem;

        @media @q-md-min {
            margin-top: 2rem;
        }
    }

    .section__title {
        .typography-h2();
        color: var(--color-darkest);

        @media @q-md-min {
            font-size: var(--font-size-3xl);
            width: 40.25rem;
        }
    }
}
</style>
